var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MOUSE_MAP_FIRST_HOVER_SYMBOL",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on-going",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#EAEFFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.234863 7.18431C0.234863 3.49267 3.22753 0.5 6.91917 0.5C10.6108 0.5 13.6035 3.49267 13.6035 7.18431C13.6035 10.876 10.6108 13.8686 6.91917 13.8686C3.22753 13.8686 0.234863 10.876 0.234863 7.18431Z",
    fill: "#EAEFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstHover);
export default __webpack_public_path__ + "static/media/firstHover.fb93ff4881e9ad50108779236abde908.svg";
export { ForwardRef as ReactComponent };